'use client'

import { useSignals } from '@preact/signals-react/runtime'
import styles from '@susu/headless-commerce/features/configurator/components/Step/Step.module.scss'
import { configuratorSignal } from '@susu/headless-commerce/features/configurator/signals/configurator'

export type ClientStepProps = {
  children: React.ReactNode
}

export const ClientStep = ({ children }: ClientStepProps) => {
  useSignals()

  return (
    <div
      data-testid={`configurator_step_${configuratorSignal.value.currentStep.value?.name.value}`}
      className={styles.step}
    >
      {children}
    </div>
  )
}
